// Import the functions you need from the SDKs you need
import { initializeApp as fbInitializeApp, getApps } from 'firebase/app';

import type { FirebaseOptions } from 'firebase/app';
import { isEmpty } from 'lodash-es';

const isInitialized = () => !isEmpty(getApps());

const initializeApp = (options: FirebaseOptions) => {
  if (!isInitialized()) {
    fbInitializeApp(options);
  }
};

export { initializeApp };
